import { get } from 'lodash'
import { round } from './math.js'

export function getCurrencySymbol(currency) {
  const SYMBOLS = {
    EUR: '€',
    USD: '$',
    CAD: '$',
    AUD: '$',
    HKD: '$',
    GBP: '£',
    JPY: '¥',
    PLN: 'zł',
    ILS: '₪',
    DKK: 'kr',
    SEK: 'kr',
    RUB: '₽',
  }
  return get(SYMBOLS, currency, currency)
}

export function getCurrencyValueAsString({
  value,
  currency = '',
  decimals = 2,
  negative,
  showPositive,
  showNegative = true,
  notGrouping = false,
  hide = false,
}) {
  if (hide) return '*****'

  const isNegative = showNegative && (negative || value < 0)
  const positive = showPositive && value > 0

  const currencyRoundedAndPositive = Math.abs(round(value, decimals)).toLocaleString(undefined, {
    maximumFractionDigits: 20,
    useGrouping: !notGrouping,
  })

  let result = ''
  if (currencyRoundedAndPositive !== '0') {
    if (positive) result += '+'
    else if (isNegative) result += '-'
  }

  if (currency === 'EUR') {
    result += `${currencyRoundedAndPositive}€`
  } else if (['USD', 'CAD', 'AUD', 'HKD'].indexOf(currency) > -1) {
    result += `$${currencyRoundedAndPositive}`
  } else if (currency === 'GBP') {
    result += `£${currencyRoundedAndPositive}`
  } else if (currency === 'JPY') {
    result += `¥${currencyRoundedAndPositive}`
  } else if (currency === 'PLN') {
    result += `${currencyRoundedAndPositive}zł`
  } else if (currency === 'ILS') {
    result += `${currencyRoundedAndPositive}₪`
  } else if (['DKK', 'SEK'].indexOf(currency) > -1) {
    result += `${currencyRoundedAndPositive}kr`
  } else if (currency === 'RUB') {
    result += `₽${currencyRoundedAndPositive}`
  } else if (currency === 'SGD') {
    result += `S$${currencyRoundedAndPositive}`
  } else {
    result += `${currencyRoundedAndPositive}${currency}`
  }

  return result
}
